import mix from '../../helpers/mix';
mix.loadCSS('css/desktop/popup.css');
mix.loadCSS(appConfig.isDesktop ? 'css/desktop/one-click-form.css' : 'css/mobile/one-click-form.css');

window.alerted = false;

// myAlert
export function alert(text, title, button, callback) {
    const div = document.createElement('div');
    div.setAttribute('id', 'popup');
    div.setAttribute('class', 'myAlerts');

    $(document).on('click', '.js-alert-close', function () {
        alerted = false;

        if (typeof callback !== 'undefined' && callback) {
            callback();
        }
    });

    if (typeof title == 'undefined' || !title) {
        // Внимание!
        title = trans('common.alert_default_caption');
    }

    if (typeof button == 'undefined' || !button) {
        // ОК
        button = 'OK';
    }

    if (!alerted) {
        div.innerHTML = `<div id="overlay">&nbsp;</div><div class="popup_wrap"><div class="popup_alert border-r"><a rel="nofollow" href="javascript:void(0)" class="crossClose js-alert-close" onclick="$('#popup').remove(); alerted=0;">X</a><div class="popup_title">${title}</div><div class="popup_caption">${text}</div><a href="javascript:void(0)" class="close js-alert-close" onclick="$('#popup').remove(); alerted=0;">${button}</a></div></div>`;

        $('#popup').show();
        alerted = true;
        return document.body.appendChild(div);
    } else {
        return false;
    }
}

// myConfirm
export function confirm(msg, func, title, but, but1) {
    if (typeof title == 'undefined') {
        // Сделайте выбор
        title = trans('common.confirm_default_caption');
    }

    if (typeof but == 'undefined') {
        // Да
        but = trans('common.confirm_default_yes');
    }

    if (typeof but1 == 'undefined') {
        // Нет
        but1 = trans('common.confirm_default_no');
    }

    const div = document.createElement('div');
    div.setAttribute('id', 'confirm');
    div.setAttribute('class', 'myAlerts');
    div.onclick = function (e) {
        const t = e ? e.target : window.event.srcElement;

        if (t.tagName === 'INPUT') {
            t.value == but && func();
            this.parentNode.removeChild(this);
        }
    };

    div.innerHTML = `<div id="overlay">&nbsp;</div><div class="popup_wrap" style="width: 345px;margin-left: -173px;"><div class="popup_alert border-r"><input type="button" value="X" class="crossClose"><div class="popup_title">${title}</div><div class="popup_caption">${msg}</div><div class="popup_action"><input type="button" class="butBlue myConfirm" value="${but}"><input type="button" class="butBlue butCancel border-r myConfirm" value="${but1}"></div>`;

    return document.body.appendChild(div);
}

// myPrompt
export function prompt(msg, defaultValue, func, title, isQuantity = true) {
    const titleBlock = title ? `<div class="popup_title">${title}</div>` : '';

    let inner = isQuantity
        ? `<div class="popup_caption">
        <p class="popup-label" style="margin-bottom: 8px">${msg}</p>
        <div class="one-click_quantity">
            <div class="quantity-down" style="align-items: center; background: #c6c6c6">–</div>
            <div class="quantity-field">
                <input type="text" inputMode="numeric" class="js-quantity js-prompt-value" min="1" max="999"
                       maxLength="3" step="1" value="1">
            </div>
            <div class="quantity-up">+</div>
        </div>
    </div>`
        : `<label class="popup_label">${msg}</label>
        <input type="text" class="popup_input js-prompt-value" value="${defaultValue}">
        `;

    let div = $('<div/>').attr('id', 'popup').addClass('myAlerts').html(`
	<div id="overlay">&nbsp;</div>
    <div class="popup_wrap" style="width: 345px;margin-left: -173px;">
        <div class="popup_alert border-r">
            <a rel="nofollow" href="javascript:void(0)" class="crossClose js-alert-close" >X</a>
            ${titleBlock}

            <div class="popup_caption">
                ${inner}
            </div>

            <div class="popup_action">
                <input type="button" class="butBlue myConfirm js-prompt-ok" value="OK"/>
                <input type="button" class="butBlue butCancel myConfirm js-alert-close" value="${trans(
                    'common.cancel'
                )}"/>
            </div>
        </div>
    </div>
	`);

    const close = () => {
        $(div).remove();
    };

    const enter = () => {
        let value = $(div).find('.js-prompt-value').val();

        if (!value) {
            value = null;
        }

        func(value);

        $(div).remove();
    };

    $(div).find('.js-alert-close').click(close);
    $(div).find('.js-prompt-ok').click(enter);
    $(div)
        .find('.js-prompt-value')
        .keyup(ev => {
            if (ev.keyCode === 13) {
                enter();
            } else if (ev.keyCode === 27) {
                close();
            }
        });

    div.on('click', '.quantity-down', function (e) {
        e.preventDefault();
        var input = $(this).parents('.one-click_quantity').find('.js-quantity');

        if (input.val() > 1) {
            $(this)
                .parents('.one-click_quantity')
                .find('.js-quantity')
                .val((i, oldval) => {
                    return --oldval;
                });
        }
    });

    div.on('click', '.quantity-up', function (e) {
        e.preventDefault();

        $(this)
            .parents('.one-click_quantity')
            .find('.js-quantity')
            .val((i, oldval) => {
                var newVal = parseInt(oldval) + 1;

                if (newVal > 999) {
                    newVal = 999;
                }

                return newVal;
            });
    });

    const result = $('body').append(div);
    const input = $(div).find('.js-prompt-value');
    input.focus()[0].setSelectionRange(0, 99999);

    return result;
}
